export default __webpack_public_path__ + "static/media/loader-logo.9c0dd004.svg";